import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/first-time-driver.jpg";
import onlineCourse from "../../assets/images/pages/online-course.jpg";
import classroomCourse from "../../assets/images/pages/classroom-traffic-school.jpg";
import firstTimeDriver from "../../assets/images/pages/first-time-course.jpg";
import matureDriverCourse from "../../assets/images/pages/mature-driver.jpg";

const TrafficSchoolProgram = () => {
  const lessonCards = [
    {
      title: "Online Course",
      link: "/online-traffic-school",
      imgSrc: onlineCourse,
    },
    {
      title: "Classroom Course",
      link: "/classroom-traffic-school",
      imgSrc: classroomCourse,
    },
    {
      title: "First Time Driver",
      link: "/first-time-driver",
      imgSrc: firstTimeDriver,
    },
    {
      title: "Mature Driver Course",
      link: "/mature-driver-course",
      imgSrc: matureDriverCourse,
    },
  ];

  const benefits = [
    "Keep your insurance from going up (Statute: 626.9541)",
    "No points on your driver's license",
    "Keep your Safe Driver Status",
    "Out of state ticket holders are eligible",
    "Receive up to a 10% discount on your car insurance for taking a voluntary Defensive Driving Course",
  ];

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">Traffic School Program</h1>
              <p className="banner-subheading">
                Please choose from our convenient classes below
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <div className="row g-4 mb-5">
            {lessonCards.map((card, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="card text-white border-0 rounded-lg overflow-hidden course-card">
                  <img
                    src={card.imgSrc}
                    className="card-img"
                    alt={card.title}
                  />
                  <div className="card-img-overlay card-img-overlay-custom d-flex flex-column justify-content-end p-4">
                    <div>
                      <h4 className="card-title fw-bold">{card.title}</h4>
                      <a
                        href={card.link}
                        className="btn btn-light rounded-lg mt-3 px-4"
                        style={{
                          backgroundColor: "var(--metro-yellow)",
                          border: "none",
                        }}
                      >
                        More Info
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="col-12">
            <ShellCard>
              <div className="row mb-5">
                <div className="col-12">
                  <p className="text-white text-center mb-0 pt-3">
                    <strong>
                      Click on our classes above to further explore the benefits
                      available of doing your Driving School course via{" "}
                      <a
                        href="/online-traffic-school"
                        style={{ color: "#f0c74c" }}
                      >
                        Internet
                      </a>
                      {" "}
                      or{" "}
                      <a href="#" style={{ color: "#f0c74c" }}>
                        Live Class
                      </a>
                      .{" "}
                    </strong>
                  </p>
                </div>
              </div>

              <div className="mb-5">
                <div className="mb-4">
                  <h3 className="h4 mb-3" style={{ color: "var(--metro-yellow)" }}>
                    Online Course
                  </h3>
                  <p className="text-white mb-0">
                    The main benefit of completing our FL Driving school online
                    course is the fact that you can do it at your own pace,
                    based on your schedule. Our Florida Online Driving School
                    course was designed with ease of use in mind. If you are a
                    student and have 15 minutes available between classes,
                    simply log on to your FL Driving School online account for
                    the 10 minutes. Just be sure to save your time before
                    exiting and you just completed 10 minutes of your required
                    hours. If you want to complete the online driving school
                    course during your lunch break or any time you have some
                    free time, our online course gives you that ability.
                  </p>
                </div>

                <div className="mb-4">
                  <h3 className="h4 mb-3" style={{ color: "var(--metro-yellow)" }}>
                    Classroom Course
                  </h3>
                  <p className="text-white mb-0">
                    If you opt for our classroom driving school course you will
                    encounter a more interactive approach to learning. We
                    strongly encourage class participation. This in turn will
                    allow students to not only learn driver education from the
                    instructor, but from each other. Our traffic school
                    instructors are well respected professional in the field of
                    driver education. Something to keep in mind is that while
                    our FL online driving school program gives you, what we feel
                    is the best online traffic school in Florida; we likewise
                    feel our classroom course provides an equally great
                    experience.
                  </p>
                </div>

                <div
                  className="p-3 rounded"
                  style={{
                    backgroundColor: "#333333",
                    border: "1px solid var(--metro-yellow)",
                  }}
                >
                  <p className="mb-0 fw-bold" style={{ color: "var(--metro-yellow)" }}>
                    Benefits of Completing one of the Courses Offered by Metro
                    Traffic School
                  </p>
                  <ul className="text-white mb-0 ml-5">
                    {benefits.map((benefit, index) => (
                      <li key={index} className="mb-2">
                        {benefit}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrafficSchoolProgram;
